module.exports = __webpack_public_path__ + "img/MEDIA019.616bf9cb.jpg";